import React from "react";

/** Renderer di una domanda della question bank Discovery (tutti i tipi). */
export const DiscoveryQuestion = ({ q, value, onChange }) => {
  const base = (
    <div className="mb-1.5">
      <label className="block text-[15px] font-medium text-text-primary leading-snug">
        {q.label}
        {!q.required && <span className="text-text-muted font-normal text-xs ml-1.5">(facoltativa)</span>}
      </label>
      {q.hint && <div className="text-xs text-text-muted mt-0.5">{q.hint}</div>}
    </div>
  );

  if (q.type === "single") {
    return (
      <div className="mb-6" data-testid={`dq-${q.qid}`}>
        {base}
        <div className="flex flex-col gap-2 mt-2" role="radiogroup" aria-label={q.label}>
          {(q.options || []).map((opt) => {
            const active = value === opt;
            return (
              <button
                key={opt}
                type="button"
                role="radio"
                aria-checked={active}
                onClick={() => onChange(opt)}
                data-testid={`dq-${q.qid}-opt`}
                className={`text-left px-4 py-3 rounded-lg border text-sm transition-colors ${
                  active
                    ? "border-accent bg-accent-subtle text-accent-strong font-medium"
                    : "border-border bg-surface text-text-primary hover:border-accent/50"
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  if (q.type === "multi") {
    const arr = Array.isArray(value) ? value : [];
    const toggle = (opt) =>
      onChange(arr.includes(opt) ? arr.filter((x) => x !== opt) : [...arr, opt]);
    return (
      <div className="mb-6" data-testid={`dq-${q.qid}`}>
        {base}
        <div className="flex flex-wrap gap-2 mt-2">
          {(q.options || []).map((opt) => {
            const active = arr.includes(opt);
            return (
              <button
                key={opt}
                type="button"
                aria-pressed={active}
                onClick={() => toggle(opt)}
                data-testid={`dq-${q.qid}-opt`}
                className={`px-3.5 py-2 rounded-full border text-sm transition-colors ${
                  active
                    ? "border-accent bg-accent-subtle text-accent-strong font-medium"
                    : "border-border bg-surface text-text-primary hover:border-accent/50"
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  if (q.type === "scale_1_5") {
    return (
      <div className="mb-6" data-testid={`dq-${q.qid}`}>
        {base}
        <div className="flex gap-2 mt-2" role="radiogroup" aria-label={q.label}>
          {[1, 2, 3, 4, 5].map((n) => (
            <button
              key={n}
              type="button"
              role="radio"
              aria-checked={value === n}
              onClick={() => onChange(n)}
              data-testid={`dq-${q.qid}-opt`}
              className={`w-11 h-11 rounded-full border text-sm font-semibold transition-colors ${
                value === n
                  ? "border-accent bg-accent text-white"
                  : "border-border bg-surface text-text-primary hover:border-accent/50"
              }`}
            >
              {n}
            </button>
          ))}
        </div>
      </div>
    );
  }

  if (q.type === "text_short") {
    return (
      <div className="mb-6" data-testid={`dq-${q.qid}`}>
        {base}
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          maxLength={120}
          data-testid={`dq-${q.qid}-input`}
          className="wl-input mt-1 w-full"
        />
      </div>
    );
  }

  // text
  return (
    <div className="mb-6" data-testid={`dq-${q.qid}`}>
      {base}
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        maxLength={2000}
        rows={3}
        data-testid={`dq-${q.qid}-input`}
        className="wl-input mt-1 w-full resize-y min-h-[80px]"
      />
    </div>
  );
};
